import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import styles from "./PromoTile.css";
import premier_small from "./premier_small.png";
import premier_medium from "./premier_medium.png";
import premier_large from "./premier_large.png";
import ImageLink from "../../../../ShopWomenAndMen/ImageLink";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../../../../state/modules/layout/constants";

const VIEWPORT_CATEGORY_TO_LOGO_MAPPIMG = {
  [SMALL_VIEWPORT]: premier_small,
  [MEDIUM_VIEWPORT]: premier_medium,
  [LARGE_VIEWPORT]: premier_large
};

const config = {
  COM: {
    translations: {
      copy: "Unlimited free next day delivery for a whole year for £9.95",
      sign_up: "SIGN UP",
      tnc: "Minimum spend and Ts&Cs apply."
    },
    linkUrl:
      "https://www.asos.com/payments-and-deliveries/premier-delivery/#ctaref-plp-tile"
  },
  US: {
    translations: {
      copy: "Unlimited free next day delivery for a whole year for $25",
      sign_up: "SIGN UP",
      tnc: "Minimum spend and Ts&Cs apply."
    },
    linkUrl:
      "https://www.asos.com/us/payments-and-shipping/premier-delivery/#ctaref-plp-tile"
  },
  FR: {
    translations: {
      copy: "LIVRAISON 24h GRATUITE illimitée PENDANT UN AN ENTIER POUR 15 €",
      sign_up: "JE SIGNE",
      tnc: "Montant d'achat minimum. Voir conditions."
    },
    linkUrl:
      "https://www.asos.com/de/zahlung-und-versand/premier-lieferung/#ctaref-plp-tile"
  },
  DE: {
    translations: {
      copy:
        "FÜR 15 € EIN JAHR LANG UNBEGRENZTE GRATIS-LIEFERUNG AM NÄCHSTEN WERKTAG",
      sign_up: "REGISTRIEREN",
      tnc: "Es gelten ein Mindestbestellwert und die AGB."
    },
    linkUrl:
      "https://www.asos.com/de/zahlung-und-versand/premier-lieferung/#ctaref-plp-tile"
  }
};

const PromoTile = ({ storeCode, viewportCategory }) => {
  const {
    translations: { copy, sign_up, tnc },
    linkUrl
  } = config[storeCode];

  const logo = VIEWPORT_CATEGORY_TO_LOGO_MAPPIMG[viewportCategory];

  return (
    <PromoTileWrapper linkUrl={linkUrl} className={styles.wrapper}>
      <div className={styles.promoTile}>
        <ImageLink url="#" image={logo} alt="asos premier"></ImageLink>
        <div className={styles.copy}>{copy}</div>
        <div className={styles.sign_up_wrapper}>
          <div className={styles.sign_up}>{sign_up}</div>
          <div className={styles.tnc}>{tnc}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired,
  viewportCategory: PropTypes.string.isRequired
};

export default PromoTile;
